export default __webpack_public_path__ + "static/media/9k.8d124380.gif";